import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { BorrowerValuesListSmartModule } from 'ng2-app/components/borrower-values-list-smart/borrower-values-list-smart.module';
import { OustandingLoansModule } from './outstanding-loans-smart/outstanding-loans.module';
import { BusinessPersonnelModule } from './business-personnel/business-personnel.module';
import { BorrowerOverviewComponent } from './borrower-overview/borrower-overview.component';
import { MonthlyTotalsModule } from 'app/monthly-totals/monthly-totals.module';
import { BorrowerTradelinesModule } from './tradelines/borrower-tradelines.module';
import { PayrollValidationComponent } from './payroll-validation/payroll-validation/payroll-validation.component';
import { PayrollValidationSmartComponent } from './payroll-validation/payroll-validation-smart/payroll-validation-smart.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    BorrowerOverviewComponent,
    PayrollValidationComponent,
    PayrollValidationSmartComponent
  ],

  imports: [
    CommonModule,
    MatGridListModule,
    MatExpansionModule,
    MatDividerModule,
    BorrowerValuesListSmartModule,
    OustandingLoansModule,

    BusinessPersonnelModule,
    BorrowerTradelinesModule,
    MonthlyTotalsModule,
    MatProgressSpinnerModule
  ],
  exports: [
    BorrowerOverviewComponent,
    OustandingLoansModule,
    BorrowerValuesListSmartModule
  ]
})

export class BorrowerOverviewModule {}
